import React from "react";
import Pricehero from "./Pricehero";
import PriceForm from "./PriceForm";
import FAQ from '../../components/FAQ'
import { HiOutlineMinusSm } from "react-icons/hi";
import { useState } from "react";

import CTA from "../../components/CTA";

const Price = () => {
  const [selectFaq, setSelecteFaq] = useState(null);
  const [arrow, setArrow] = useState();
  const content = [
    {
      id:1,
      title: "Lorem ipsum dolor sit amet, consectetur adipiscin?",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit id venenatis pretium risus euismod dictum egestas orci netus feugiat ut egestas ut sagittis tincidunt phasellus elit etiam cursus orci in. Id sed montes. ",
    },
    {id:2,
      title: "Lorem ipsum dolor sit amet, consectetur adipiscin?",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit id venenatis pretium risus euismod dictum egestas orci netus feugiat ut egestas ut sagittis tincidunt phasellus elit etiam cursus orci in. Id sed montes. ",
    },
    {id:3,
      title: "Lorem ipsum dolor sit amet, consectetur adipiscin?",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit id venenatis pretium risus euismod dictum egestas orci netus feugiat ut egestas ut sagittis tincidunt phasellus elit etiam cursus orci in. Id sed montes. ",
    },
    {id:4,
      title: "Lorem ipsum dolor sit amet, consectetur adipiscin?",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit id venenatis pretium risus euismod dictum egestas orci netus feugiat ut egestas ut sagittis tincidunt phasellus elit etiam cursus orci in. Id sed montes. ",
    },
    {id:5,
      title: "Lorem ipsum dolor sit amet, consectetur adipiscin?",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit id venenatis pretium risus euismod dictum egestas orci netus feugiat ut egestas ut sagittis tincidunt phasellus elit etiam cursus orci in. Id sed montes. ",
    },
  ];
  const handleShowContent = (id) => {
    if (selectFaq) {
      setSelecteFaq(null);
    } else {
      setSelecteFaq(id);
    }
  };
  return (
    <div>
      <Pricehero></Pricehero>
      <PriceForm></PriceForm>
      <div className="faq-main">
        <p>Frequently Asked Questions</p>
        <h1>What Do You Need Help With?</h1>
        <div className="faq-box">
          {content.map((val, i) => (
            <FAQ
              key={i}
              showContent={selectFaq === val.id ? true : false}
              handleSelectFaq={() => handleShowContent(val.id)}
              title={val.title}
              answer={val.content}
            ></FAQ>
          ))}
        </div>
      </div>
      <CTA></CTA>
    </div>
  );
};

export default Price;
